
export default

class Client {

    constructor(id, name, status = true) {
        this.id = id
        this.name = name
        this.status = status
        this.show_in_register = true
        this.isDeveloperClient = false
        this.mobilization_date =  new Date().toISOString().substr(0, 10)
        this.vacancy_per_apt = 0
        this.class = 'A'
        this.phone_client
    }
}